export default function Privacy() {
  return (
    <main className="max-w-2xl mx-auto px-4 sm:px-8 pt-10 pb-24 text-sm text-[#444] leading-relaxed">
      <div className="text-xs uppercase tracking-[0.2em] text-[#C06F52] mb-2">Legal</div>
      <h1 className="font-serif-display text-3xl sm:text-4xl text-[#2C4C3B] leading-tight mb-8">
        Privacy &amp; terms.
      </h1>

      <section className="mb-8">
        <h2 className="font-serif-display text-xl text-[#2C4C3B] mb-2">What we collect</h2>
        <p>
          Your name and email (to run your account), the profile details you enter (age, height,
          weight, activity level, dietary restrictions and any free-text notes), the meal plans we
          generate for you, and any meal photos you upload to the photo log.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="font-serif-display text-xl text-[#2C4C3B] mb-2">How we use it</h2>
        <p>
          Solely to run Notch: calculating your targets, generating meal plans and grocery lists,
          and estimating macros from photos you upload. Your password is stored as a salted hash —
          we never see or store it in plain text. We don't sell your data or share it with
          advertisers, and we don't use it to train third-party AI models beyond the single request
          needed to generate your plan or analyse your photo.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="font-serif-display text-xl text-[#2C4C3B] mb-2">Where it lives</h2>
        <p>
          Your data is stored on Cloudflare's infrastructure (D1 database and R2 object storage).
          Meal-plan and photo analysis is generated using Cloudflare Workers AI. Your login token is
          kept in your browser's local storage — signing out clears it from that device.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="font-serif-display text-xl text-[#2C4C3B] mb-2">Your choices</h2>
        <p>
          You can delete a shared plan link at any time by contacting us. Want your account or data
          deleted entirely? Email us and we'll take care of it.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="font-serif-display text-xl text-[#2C4C3B] mb-2">Not medical advice</h2>
        <p>
          Notch's suggestions — including calorie/macro targets and photo-based estimates — are a
          starting point, not medical or dietetic advice. Always check with a qualified professional
          before making significant changes to your diet, especially if you have a medical condition
          or allergy.
        </p>
      </section>

      <section>
        <h2 className="font-serif-display text-xl text-[#2C4C3B] mb-2">Questions?</h2>
        <p>
          Reach us anytime at{" "}
          <a href="mailto:hi@sahana.cc" className="text-[#2C4C3B] font-medium hover:underline">
            hi@sahana.cc
          </a>
          .
        </p>
      </section>
    </main>
  );
}
